<template>
  <div>
    <Card>
      <div class="title"><span></span>招标文件信息</div>
      <Form :model="details" inline :label-width='300'>
        <FormItem style="width:100%" label="项目名称: ">{{details.pname}}</FormItem>
        <FormItem style="width:100%" label="项目概况及采购范围: ">
          <pre class="pre_box"><p v-html="details.overview"></p></pre>
        </FormItem>
        <FormItem label="联系人: ">{{details.contact}}</FormItem>
        <FormItem label="联系电话: ">{{details.contactNumber}}</FormItem>
        <FormItem label="报名起始时间: ">{{details.registrationStartTime}}</FormItem>
        <FormItem label="报名截止时间: ">{{details.registrationDeadline}}</FormItem>
        <FormItem label="开标时间: ">{{details.tenderOpenTime}}</FormItem>
      </Form>
    </Card>
    <Card>
      <div class="title"><span></span>{{isApply?'投标联系人信息':'投标详情'}}</div>
      <Form v-if="isApply" :model="applyForm" ref="applyFormRef" inline :label-width='300' :rules="applyRules">
        <FormItem label="联系人:" prop="contact">
          <Input v-model="applyForm.contact" clearable placeholder="请输入联系人" />
        </FormItem>
        <FormItem label="联系人手机:" prop="contactNumber">
          <Input v-model="applyForm.contactNumber" clearable placeholder="请输入联系人手机号" />
        </FormItem>
      </Form>

      <Form v-else :model="tenderForm" ref="tenderFormRef" inline :label-width='300' :rules="tenderRules">
        <FormItem label="投标金额(万元):" prop="tenderAmount">
          <InputNumber style="width:100%" v-model="tenderForm.tenderAmount" clearable placeholder="请输入投标金额" />
        </FormItem>
        <FormItem label="投标文件:" prop="fileId">
          <UploadFile ref="UploadFileRef" v-model="tenderForm.fileId"></UploadFile>
        </FormItem>
      </Form>
    </Card>
    <div class="action_btns">
      <Button style="margin-right:20px" @click="$router.go(-1)">取消</Button>
      <Button type="primary" @click="handleSubmit">确认</Button>
    </div>
  </div>
</template>
<script>
import { getProjectInfoDetail, participatoryUnitApply, updateParticipatoryUnitFile } from '@/api/api'
import UploadFile from '@/components/UpLoad'
import { validatePhone } from '@/utils/valide.js'
export default {
  components: {
    UploadFile
  },
  data () {
    return {
      details: {},
      applyForm: {
        contact: '',
        contactNumber: '',
        managementId: ''
      },
      applyRules: {
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactNumber: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ]
      },
      tenderForm: {
        fileId: null,
        tenderAmount: null,
        unitId: ''
      },
      tenderRules: {
        tenderAmount: [{ type: 'number', required: true, message: '请输入投标金额', trigger: 'blur' }],
        fileId: [
          { type: 'number', required: true, message: '请上传文件', trigger: 'blur' }
        ]
      },
      isApply: false
    }
  },
  created () {
    getProjectInfoDetail(this.$route.query.id).then(res => { this.details = res })
    this.isApply = this.$route.name === 'apply'
  },
  methods: {
    handleSubmit () {
      if (this.isApply) {
        this.$refs.applyFormRef.validate((valid) => {
          if (valid) {
            this.applyForm.managementId = this.$route.query.id
            participatoryUnitApply(this.applyForm).then(res => {
              this.$Message.success('操作成功!')
              this.$store.commit('deleteTabs', this.$route.fullPath)
              this.$router.go(-1)
            }).catch(err => console.log(err))
          } else {
            this.$Message.error('请填写联系人/联系人手机!')
          }
        })
      } else {
        this.$refs.UploadFileRef.upload().then(() => {
          this.$refs.tenderFormRef.validate((valid) => {
            if (valid) {
              this.tenderForm.unitId = this.$route.query.id
              updateParticipatoryUnitFile(this.tenderForm).then(res => {
                this.$Message.success('操作成功!')
                this.$store.commit('deleteTabs', this.$route.fullPath)
                this.$router.go(-1)
              }).catch(err => console.log(err))
            } else {
              this.$Message.error('请填写投标金额/上传投标文件!')
            }
          })
        })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.ivu-card {
  margin-bottom: 30px;
  ::v-deep .ivu-card-body {
    padding: 20px 30px;
    .title {
      font-size: 16px;
      font-weight: 550;
      color: #333333;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: #006dc8;
        margin-right: 12px;
      }
    }
    .ivu-form {
      margin: 50px 0 20px 0;
      .ivu-form-item {
        width: 49%;
        .ivu-form-item-label {
          color: #666;
          text-align: center;
        }
        .ivu-form-item-content {
          color: #333;
        }
      }
    }
  }
}
.action_btns {
  text-align: center;
  .ivu-btn {
    width: 88px;
  }
}
.pre_box {
  margin: 0;
  padding: 2px 0;
  white-space: pre-wrap;
  width: 72%;
}
</style>
